"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-9.84a1.27 1.27 0 00.167-.182.52.52 0 00.12-.32c0-.22-.047-.363-.116-.444a.217.217 0 00-.171-.08.216.216 0 00-.172.08c-.068.08-.115.224-.115.445 0 .061.012.121.04.184l-.003-.005c-.228.177-.809.482-1.264.665a2.104 2.104 0 01-.175-.844c0-.595.17-1.114.49-1.493.314-.37.745-.571 1.199-.571.454 0 .885.201 1.198.571.32.379.49.899.49 1.493 0 .395-.107.768-.31 1.104-.363.58-.72.876-1.546 1.246l-4.458 1.95c-.098.044-.21-.007-.25-.114a.228.228 0 01-.014-.08V8.108c0-.058.048-.123.095-.105.88.25 1.514.788 1.514 1.51v4.223c0 .02.02.034.038.026l1.849-.86c.5-.2 1.136-.532 1.394-.741zm1.675.87l1.52.731a.027.027 0 00.038-.025V9.513c0-.722.682-1.26 1.537-1.507.05-.014.103.02.116.075.002.006.003 1.888.004 7.684 0 .116-.086.21-.192.21a.178.178 0 01-.072-.016l-4.15-1.807c.559-.307.886-.625 1.2-1.122z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;